<template>
  <div class="date-input-mask">
    <div class="input-content">
      <div class="row">
        <div class="col-5">
          <h5>年份</h5>
          <div :class="{ 'bg-date-number': true, 'date-selected': n === year }" v-for="n in yearRange" @click="year = n">
            <span>{{ n }}</span>
          </div>
        </div>
        <div class="col-7">
          <h5>月份</h5>
          <div :class="{ 'bg-date-number': true, 'date-selected': n === month }" v-for="n in (1,12)" @click="month = n">
            <span>{{ n }}</span>
          </div>
        </div> 
      </div>
      <br>
      <div class="row">
        <div class="col-12">
          <h5>日期</h5>
          <div :class="{ 'bg-date-number': true, 'date-selected': n === day }" v-for="n in days" @click="day = n">
            <span>{{ n }}</span>
          </div>
        </div>
      </div>
      <div class="submit-date" @click="saveDate">提交日期</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DateInput',
  props: ['defaultDate', 'limitedDate'],
  data() {
    return {
      month: '',
      year: '',
      day: '',
      days: '',
      yearRange: [],
    };
  },
  watch: {
    month() {
      if ([1, 3, 5, 7, 8, 10, 12].indexOf(this.month) !== -1) {
        this.days = 31;
      } else if ([4, 6, 9, 11].indexOf(this.month) !== -1) {
        this.days = 30;
      } else {
        this.days = 28;
      }
    },
  },
  mounted() {
    if (this.defaultDate !== '') {
      const date = new Date(this.defaultDate);
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1; // javasctipt return [0-11] for month... this is so weird...
      this.day = date.getDate();
    }
    this.yearRange = Array(10);
    const thisYear = parseInt(new Date().getFullYear(), 10);
    for (let i = 0; i < 10; i += 1) this.yearRange[i] = thisYear + i;
  },
  methods: {
    saveDate() {
      const date = moment(`${this.year}-${this.month}-${this.day}`, 'YYYY-MM-DD');
      if (moment(date).isBefore(moment())) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '設定效期不可以早於今日',
        });
      } else {
        if (this.limitedDate) {
          if (moment(date).isAfter(moment(this.limitedDate))) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: `設定效期不可以晚於${moment(this.limitedDate).format('YYYY-MM-DD')}`,
            });
          } else {
            this.$emit('saveDate', date.format('YYYY-MM-DD'));
          }
        } else {
          this.$emit('saveDate', date.format('YYYY-MM-DD'));
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.date-input-mask
  position: fixed
  top: 0 
  left: 0
  height: 100vh
  width: 100vw
  z-index: 10
  background: rgba(0,0,0,0.3)
  display: flex
  .input-content
    background: white
    max-width: 800px
    padding: 20px
    margin: auto
    border-radius: 5px

.bg-date-number
  width: 60px
  height: 60px
  display: inline-block
  background-color: #6f7e95
  color: white
  font-size: 16px
  margin: 1px
  cursor: pointer;
  user-select: none
  &:active
    box-shadow: inset 0 0 10px #000000;
  span
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    align-items: center

.date-selected
  background: #FF3811
  color: white

.submit-date
  padding: 15px 0
  text-align: center
  width: 100%
  border: 1px solid rgba(0,0,0,0.3)
  margin-top: 20px
  &:active
    color: white
    background: #6f7e95

.row
  display: flex
  margin: 0px

[class*='col-']
  padding: 0
</style>




// WEBPACK FOOTER //
// DateInput.vue?1305c18c